export function groupByDay(list, keyGetter) {
  if (list.length) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });

    const collectionObject = Object.fromEntries(map);

    let newCollection = [];

    for (let key in collectionObject) {
      const object = {
        weekday: Number(key),
        items: collectionObject[key],
      };

      newCollection.push(object);
    }

    return newCollection;
  } else {
    console.log("no hay nada");
    return [];
  }
}
